<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">
    <!-- <img class="background-img col-12 cover h100" src="../assets/cls_sideview.png"> -->


    <!-- Headerbar Start -->

    <cql-headerbar/>

  

    <div class="overview-container overflow-hidden ">
      
      <div class="relative">
          <div class="eingabe" v-show="step == 'eingabe'">
              <eingabe/> 
          </div>
          <div v-if="showdebug" class="debug-container box-shadow-big" :class="{showdebug: debug}">
              <div class="debug-button pointer" @click="debug = !debug">
                <p>{{$t('calculation_debug')}}</p>
              </div>
              <div style="width: 600px; height: 600px; overflow-y: scroll;">
                <debug/> 
              </div>
          </div>
        </div>
      

    </div>
  </div>
</template>


<script>
import Eingabe from './Eingabe.vue';
import Debug from './Debug.vue';
import cqlHeaderbar from './cqlHeaderbar.vue';


import { EventBus } from "../event-bus";
// import axios from 'axios'

export default {
  data() {
    return {
      showdebug: false,
      debug: false,
      step: 'eingabe',
      langs: ['de', 'en', 'es', 'fr'],
      username: 'nicht eingeloggt!',
      userdata: {},
      session: {},
      loginStatus: false,
      selected_project: 0,
     
    };
  },
  created: function () {
    //console.log('QaL.vue created!');
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      //console.log('QaL.vue recieved Event: "loginSuccessful"!');
      this.userdata = payload.userdata;
      this.username = payload.userdata.company  + " " + payload.userdata.firstname + " " + payload.userdata.name;
      this.session = payload.session;
      this.loginStatus = true;
    });
    EventBus.$on('loginNotCorrect', () => {
      this.$router.push({ path:'/' + this.$il8n.locale + '/logout-session'});
    });
    /*EventBus.$on('update_selected_project', (selected_project) => {
      //console.log('QaL.vue recieved Event: "update_selected_project"!');
      this.selected_project = selected_project;
    });*/
  },
  mounted: function () {
    //console.log('QaL.vue: emitting Event: loginCheckQaL');
     EventBus.$emit('loginCheckQaL', {
    });
  },
 
  components: {
    // 'onboarding-step-01' : OnboardingStep01,
    'eingabe' : Eingabe,
    'debug' : Debug,
    'cql-headerbar' : cqlHeaderbar
   },
  methods: {
    reprint: function (newstep) {

        if(newstep == undefined || newstep == '') {
            this.log('ERROR: App.vue: reprint() called with undefined newstep!')
        } else {
            
            EventBus.$emit('dataRefresh', {
                'onboardingData': this.onboardingData
            });

            this.log('App.vue: reprint().called()');
            this.log('App.vue: reprint() Old-Step: ' + this.step);
            this.step = newstep;
            this.log('App.vue: reprint() New-Step: ' + newstep);
        }

        this.log('BOC Collected Data:');
        this.log(this.onboardingData)
        this.log('EOC Collected Data:');
    },

    log: function (obj) {
      if(this.debug) {
        console.log(obj)
      }
    },
    newProjectModal() {
        this.createNewModal = true;
    },
    setResultsStep(){
      this.step = 'results';
      EventBus.$emit('resetAlert');
    },
    logOut(){
      //logout Logic
    }



  },

};
</script>
<style>
</style>
